module.exports = __webpack_public_path__ + "820c901af5d4c022bd81b18c8fe6c3af.svg";